import { halcyonFormCatalogApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const HALCYON_FORM_CATALOG_ACTION_TYPE = createNamedActions('halcyonFormCatalog', {
  GET_HALCYON_FORM_CATALOG: 'GET_HALCYON_FORM_CATALOG',
});

export const loadHalcyonFormCatalogAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await halcyonFormCatalogApi.getFormCatalog();

  return dispatch({
    type: HALCYON_FORM_CATALOG_ACTION_TYPE.GET_HALCYON_FORM_CATALOG,
    payload: data,
  });
});
